import { ATTRIBUTES } from '../constants';
import { extractJsonFieldSql } from './extractJsonFieldSql';
import { ModuleEnum } from '../enums/ModuleEnum';
import { LocalesEnum } from '../enums/LocalesEnum';
import { lower } from '../lower';

const valueFireAnSmoke = [
  JSON.stringify(['Fire & Smoke']),
  JSON.stringify(['Fire And Smoke']),
  JSON.stringify(['Fire Protection']),
];
const valueRefrigerant = [ 'Refrigerant', JSON.stringify(['Refrigerant']) ];
const valueWater = [ 'Water', JSON.stringify(['Water']) ];
const valueAir = [ 'Air', JSON.stringify(['Air']) ];
const valveTypeValue = JSON.stringify(['Valve']);
const actuatorTypeValue = JSON.stringify(['Actuator']);
const valveActuatorUnitTypeValue = JSON.stringify(['Valve-actuator unit']);
const sensorTypeValue = JSON.stringify(['Sensor']);
const notDiscontinuedFlag = JSON.stringify(['0']);

export const buildConditionForAllValidModules = (rawName: LocalesEnum): [string, string[]] => [`
lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?,?,?,?,?)
AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) is not null
AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) not like 'fire%%'
AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) not like 'room%%'
AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) NOT IN (?,?)
`, [valveTypeValue, valveActuatorUnitTypeValue, sensorTypeValue, actuatorTypeValue, JSON.stringify(['Accessory']), ...valueRefrigerant].map(lower)];

export const buildWhereByModule = (
    module: ModuleEnum,
    rawName: LocalesEnum,
    discontinuedAttr: string,
): [string, string[]] => {
    switch (module) {
      case ModuleEnum.water: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?,?)
        `, [...valueWater, actuatorTypeValue, valveActuatorUnitTypeValue].map(lower)];
      }
      case ModuleEnum.air: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) = ?
        `, [...valueAir, actuatorTypeValue].map(lower)];
      }
      case ModuleEnum.sensor: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) = ?
        `, [sensorTypeValue].map(lower)];
      }
      case ModuleEnum.waterByValve: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?,?)
        `, [...valueWater, valveTypeValue, valveActuatorUnitTypeValue].map(lower)];
      }
      case ModuleEnum.WaterSolution:
      case ModuleEnum.SensorSolution:
      case ModuleEnum.findByDesign: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?,?)
        `, [...valueWater, actuatorTypeValue, valveActuatorUnitTypeValue].map(lower)];
      }
      case ModuleEnum.AirSolution: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) = ?
        `, [...valueAir, actuatorTypeValue].map(lower)];
      }
      case ModuleEnum.ValveSolution: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?,?)
        `, [...valueWater, valveTypeValue, valveActuatorUnitTypeValue].map(lower)];
      }
      case ModuleEnum.FireAndSmoke: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?,?)
        `, [...valueFireAnSmoke].map(lower)];
      }
      case ModuleEnum.FireAndSmokeSolution: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) = ?
        `, [...valueFireAnSmoke, actuatorTypeValue].map(lower)];
      }
      case ModuleEnum.ValveSizer: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.APPLICATION_TYPE}.${rawName}`)}) IN (?,?)
        AND lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?,?)
        AND (${extractJsonFieldSql('attributes', `$.${discontinuedAttr}.${rawName}`)}) = ?
        `, [...valueWater, valveTypeValue, valveActuatorUnitTypeValue, notDiscontinuedFlag].map(lower)];
      }
      case ModuleEnum.ActuatorSizer: {
        return [`
          lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) IN (?)
          AND (${extractJsonFieldSql('attributes', `$.${discontinuedAttr}.${rawName}`)}) = ?
        `, [actuatorTypeValue, notDiscontinuedFlag].map(lower)];
      }
      case ModuleEnum.SensorSizer: {
        return [`
        lower(${extractJsonFieldSql('attributes', `$.${ATTRIBUTES.PRODUCT_TYPE_ATTR}.${rawName}`)}) = ?
        AND (${extractJsonFieldSql('attributes', `$.${discontinuedAttr}.${rawName}`)}) = ?
        `, [sensorTypeValue, notDiscontinuedFlag].map(lower)];
      }
      default:
        throw new Error('unknown module');
    }
};
